import type { JsonMetadata, surveyLocalization } from 'survey-core'
import { japaneseSurveyStrings } from './localization/japanese'

type SurveyLocalization = typeof surveyLocalization

export const PROPERTY_KEY_IMAGEPICKER_SHOW_CAPTION = 'showCaption'
export const PROPERTY_KEY_IMAGEPICKER_DISPLAY_COLUMN_SIZE = 'displayColumnSize'

export const PROPERTY_KEY_USAGE = 'usage'
export const PROPERTY_KEY_USAGE_VALUE_NORMAL_IMAGE = 'normalImage'
export const PROPERTY_KEY_USAGE_VALUE_RECEIPT_IMAGE = 'receiptImage'
export const PROPERTY_KEY_USAGE_VALUE_BARCODE_IMAGE = 'barcodeImage'
export const PROPERTY_KEY_VALIDATION_TYPE = 'validationType'

/**
 * custom propertyを追加する
 * core packageでも利用したかったので共通化
 */
export function initSurveySettings(surveySerializer: JsonMetadata, surveyLocalization: SurveyLocalization) {
  // import 'survey-core/i18n/japanese' だけでsurveyLocalization(グローバル変数)に↓の設定が行われるはずだが、ビルド次第で参照できないことがある
  // (survey-creatorの設定が反映されない問題と同じ事象であると思われる)
  // BEGIN
  surveyLocalization.supportedLocales = ['ja']
  surveyLocalization.locales.ja = japaneseSurveyStrings
  surveyLocalization.localeNames.ja = '日本語'
  // END
  surveyLocalization.locales.ja.pagePrevText = '戻る'
  surveyLocalization.locales.ja.booleanCheckedLabel = 'はい'
  surveyLocalization.locales.ja.booleanUncheckedLabel = 'いいえ'
  surveyLocalization.defaultLocale = 'ja'

  surveySerializer.addProperty('imagepicker', {
    category: 'general',
    name: PROPERTY_KEY_IMAGEPICKER_SHOW_CAPTION,
    type: 'boolean',
    displayName: 'キャプションを表示',
  })

  surveySerializer.addProperty('imagepicker', {
    category: 'general',
    name: PROPERTY_KEY_IMAGEPICKER_DISPLAY_COLUMN_SIZE,
    type: 'dropdown',
    displayName: '表示カラム数',
    choices: [
      { value: 'two', text: '2カラム' },
      { value: 'one', text: '1カラム' },
    ],
    default: 'two',
  })

  /**
   * file の質問のプロパティに 用途 を追加
   * refer: https://surveyjs.io/form-library/documentation/customize-question-types/add-custom-properties-to-a-form#add-custom-properties-to-an-existing-class
   */
  surveySerializer.addProperty('file', {
    category: 'general',
    name: PROPERTY_KEY_USAGE,
    displayName: '用途',
  })

  // validationTypeプロパティ
  const validationChoices = [
    { value: 'none', text: 'なし' },
    { value: 'alphanumericWithSymbols', text: '半角英数記号のみ' },
    { value: 'alphanumericOnly', text: '半角英数のみ' },
  ]

  /**
   * フリーテキスト（単語・文章）に「半角英数記号のみ」のプロパティを追加
   */
  surveySerializer.addProperty('text', {
    name: PROPERTY_KEY_VALIDATION_TYPE,
    displayName: '入力制限',
    category: 'validation',
    type: 'dropdown',
    choices: validationChoices,
    default: 'none',
  })

  surveySerializer.addProperty('comment', {
    name: PROPERTY_KEY_VALIDATION_TYPE,
    displayName: '入力制限',
    category: 'validation',
    type: 'dropdown',
    choices: validationChoices,
    default: 'none',
  })
}
